import { Base64 } from 'js-base64';

/**
 * Decode the payload part of a JWT.
 * @param {String} JWT
 * @return {Object} decoded JWT. Returns null if JWT is invalid.
 *
 * Decoded JWT looks like:
 * {
 *  "token_type": "access",
 *  "exp": 1607137828,
 *  "jti": "59539b914a7244c192dbd641ee88bcde",
 *  "user_id": 3
 * }
 *
 * - 'exp' is the expiry date of the token in epoch
 * - 'jti' is the JWT ID
 */
export function parseJWT(JWT) {
    // A serialized JWT is in the format {header}.{payload}.{signature} encoded in base64, extract the payload portion.
    // Check if JWT if null or undefined.
    // This is done for situations where no JWT token is passed
    if (JWT === null || typeof JWT === 'undefined') {
        return null;
    }
    const payloadInBase64 = JWT.split('.')[1];
    // decode base64 payload
    const decodedPayload = Base64.decode(payloadInBase64);
    // The decodedPayload is an object as a string representation, return it as an actual JS object.

    let decodedJWT = null;
    try {
        decodedJWT = JSON.parse(decodedPayload);
    } catch (error) {
        console.error(`Failed to parse JWT payload due to: ${error}`);
    }

    return decodedJWT;
}

/**
 * Determine if a token is still valid.
 * @param {Object} decodedJWT
 * @return {Boolean}
 */
export function isTokenValid(decodedJWT) {
    // Check if JWT if null.
    // This is done for situations where no signalRAccessToken is passed
    if (decodedJWT === null) {
        return false;
    }
    // additional time before expiry to try to refresh
    const EXPIRY_FUDGE_MS = 30 * 1000; // 30 seconds
    // compare time now to token's exp which (seconds since epoch)
    return Date.now() < decodedJWT['exp'] * 1000 - EXPIRY_FUDGE_MS;
}
